<script lang="ts">
	import { Button, Select, Text } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import { app, os } from 'src/stores/session/native-bridge';
	import { BLU_STATUS } from 'src/types/requests/settings/blu_status';
	import { controlBleDevice } from 'src/stores/features/ble/control-device';
	import { control_bluetooth_device_ios } from 'src/services/native_container_requests_ios';
	import { control_bluetooth_device_android } from 'src/services/native_container_requests_android';
	import { bulkUpdate } from '../ApplicationSettings/app_settings_helper';

	export let device;

	let initialized = false;
	let clockFormat = device?.clockFormat || '24-hour';
	const options = [
		{ title: $format('select_option_12_hour', { default: '12-hour' }), value: '12-hour' },
		{ title: $format('select_option_24_hour', { default: '24-hour' }), value: '24-hour' },
	];

	$: switch ($controlBleDevice.currentStatusIndex) {
		// after receiving one of the statuses below remove the initialized state
		case BLU_STATUS.UNHANDLED_STATE:
		case BLU_STATUS.BUTTON_PRESS_REQUIRED:
		case BLU_STATUS.CONNECT_TO_DEVICE:
		case BLU_STATUS.DISCONNECT_FROM_DEVICE:
			initialized = false;
			break;
		// after receiving one of the statuses below add the initialized state
		case BLU_STATUS.DEVICE_OTA_AVAILABLE:
		case BLU_STATUS.DEVICE_OTA_REQUIRED:
		case BLU_STATUS.DEVICE_PROCESSED:
		case BLU_STATUS.UTC_OFFSET_SET:
		case BLU_STATUS.TEMPERATURE_OFFSET_SET:
		case BLU_STATUS.HUMIDITY_OFFSET_SET:
		case BLU_STATUS.DARK_THRESHOLD_SET:
		case BLU_STATUS.BRIGHT_THRESHOLD_SET:
		case BLU_STATUS.INVERT_DISPLAY_ENABLED:
		case BLU_STATUS.INVERT_DISPLAY_DISABLED:
		case BLU_STATUS.FAHRENHEIT_ENABLED:
		case BLU_STATUS.FAHRENHEIT_DISABLED:
		case BLU_STATUS.CLOCK_SYNC_ENABLED:
		case BLU_STATUS.CLOCK_SYNC_DISABLED:
		case BLU_STATUS.POWER_SAVER_ENABLED:
		case BLU_STATUS.POWER_SAVER_DISABLED:
		case BLU_STATUS.ZIGBEE_ENABLED:
		case BLU_STATUS.ZIGBEE_DISABLED:
		case BLU_STATUS.CLOCK_MODE_SET:
			initialized = true;
			break;
		default:
			break;
	}

	const onSave = () => {
		const isIOS = $os === 'IOS';
		if ($controlBleDevice.connectionState === 2) {
			const command = clockFormat === '12-hour' ? 'clockMode12' : 'clockMode24';
			isIOS
				? control_bluetooth_device_ios(device.id, command)
				: control_bluetooth_device_android(device.id, command);

			bulkUpdate(device.id, { clockFormat });
		} else {
			isIOS
				? control_bluetooth_device_ios(device.id, 'connect')
				: control_bluetooth_device_android(device.id, 'connect');
		}
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('text_clock_format', {
		default:
			'Choose how time is displayed on your device. Switch between the 12-hour and 24-hour format.',
	})}
</Text>

<Select
	id="select-clock-format"
	aria-label={$format('select_clock_format', { default: 'Select clock format' })}
	size="m"
	width="full"
	class="mb-s"
	icon="fas fa-clock"
	{options}
	value={{
		title: $format(`select_option_${clockFormat.toLowerCase().replace(/[\s-]/g, '_')}`, {
			default: clockFormat,
		}),
		value: clockFormat,
	}}
	on:change={(e) => (clockFormat = e.detail.value)}
/>

<Button disabled={!initialized || !$app} size="m" width="full" on:click={onSave}>
	{$format('button_save', { default: 'Save' })}
</Button>
